import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_OPENED_SCHEMA = Object.freeze({
  PREVIOUSLY_EXISTED: false,
  SCREEN_NAME: '',
  BILLED_STATUS: null,
});
const RECORD = generateSchema(TRACKING_OPENED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_OPENED_SCHEMA);

export class OpenedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.opened;
  }

  get properties() {
    return this.toJS();
  }
}
